<div class="mi-request">

    @if(!isHomePage()){
    <mi-app-header></mi-app-header>
    }

    <main>
        <div class="mi-request-main">

            <div class="row justify-content-center mi-request-main-header" id="mi-request-main-header">
                <div class="col-md-11">
                    @if(isNeedMainHeader)
                    {
                    <div class="d-none d-sm-flex justify-content-between mc-mt-3">
                        <b class="mi-request-main-header-title">
                            {{this.requestText?.main?.header?.title}}
                        </b>
                        <!-- <button>פירוט המוצרים לבקשה</button> -->
                    </div>
                    @if(isNeedProgress)
                    {
                    <mi-app-progress></mi-app-progress>
                    }

                    }

                </div>
            </div>

            <router-outlet />
        </div>
    </main>

    @if(!isHomePage()){
    <mi-app-footer></mi-app-footer>
    }
</div>